import { render, staticRenderFns } from "./builder.vue?vue&type=template&id=4f6a6e41&scoped=true"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"
import style0 from "./builder.vue?vue&type=style&index=0&id=4f6a6e41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a6e41",
  null
  
)

export default component.exports